import { Box, Grid, Radio, Stack, Typography } from '@mui/material';
import { FieldIcon } from '/@/components/field-info-v2/field-card';
import colors from '/@/components/theme-provider/colors';
import { useUnitProvider } from '/@/core/context/unit';
import settings from '/@/core/settings';
import { useGetUserNode } from '/@/hooks/nodes';
import { _ } from '/@/locale';
import type { Field } from '/@/types/field';

function FieldItem({
    field,
    fieldIsSelected,
    setSelectedField,
    dataTestId,
    showGrowerLabel = true,
}: {
    field: Field;
    fieldIsSelected?: boolean;
    setSelectedField: (selected: Field) => void;
    dataTestId?: string;
    showGrowerLabel?: boolean;
}) {
    const units = useUnitProvider();
    const userNodeQuery = useGetUserNode(field.userNode);

    return (
        <Stack
            direction='row'
            alignItems='center'
            spacing={2}
            px={2}
            py={1.5}
            onClick={() => setSelectedField(field)}
            backgroundColor={
                fieldIsSelected ? colors.themes[settings.app.theme].mui.primary.itemSelectedBackground : 'white'
            }
            sx={{ cursor: 'pointer', border: '1px solid lightgray', width: '100%' }}
            data-testid={dataTestId}
        >
            <Box sx={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <FieldIcon coordinates={field.geometry} selected />
            </Box>
            <Grid container width='100%' alignItems='center'>
                <Grid item xs={12} sm={8}>
                    {showGrowerLabel && userNodeQuery.data?.name && (
                        <Typography
                            variant='overline'
                            color='primary.mui.inactive'
                            sx={{ flexGrow: 1, wordBreak: 'break-word' }}
                        >
                            {userNodeQuery.data.isSelf ? _('Mi cuenta') : userNodeQuery.data.name}
                        </Typography>
                    )}
                    <Typography
                        className='mp-mask'
                        variant='subtitle1'
                        fontWeight='bold'
                        color='primary'
                        sx={{ flexGrow: 1, wordBreak: 'break-word' }}
                    >
                        {field.name}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={4} sx={{ pl: 2 }}>
                    {field.recommendedCornYield && (
                        <Typography variant='body1' color='primary' sx={{ flexGrow: 1, wordBreak: 'break-word' }}>
                            {units.toYield(field.recommendedCornYield, 'corn').toString()}
                        </Typography>
                    )}
                </Grid>
            </Grid>

            <Radio checked={fieldIsSelected} value={field} color='secondary' size='medium' />
        </Stack>
    );
}

export default FieldItem;
